export const LIST_NAME = `planResources`
export const getBasicUrl = planId => `/plans/${planId}/resources`
export const getUpdateUrl = planId => `/plans/${planId}`
export const queryParams = view => ({
  limit: -1,
  orderBy: `name asc`,
  view: view || `ALL`,
})
